module.exports = __webpack_public_path__ + "static/media/let9.de9da0d3.JPG";